// copy paste values witout importing for now
export const TILE_SIZE = 12 / 0.3048 // pixels, using imperial conversion rate to preserve render scale

export const BOUNDARY_WIDTH = 360
export const GROUND_BASELINE_HEIGHT = 44
